//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import Badge, { BadgeType } from '@components/atoms/badge/Badge';
import HelpIcon from '@components/atoms/help-icon/HelpIcon';
import { BodyText } from '@components/atoms/text/Text';

interface TypeaheadSearchFieldLabelProps {
  helpText: string;
  labelText: string;
}

export const TypeaheadSearchFieldLabel = ({
  helpText,
  labelText,
}: TypeaheadSearchFieldLabelProps) => {
  return (
    <>
      <LabelHelpIcon>
        <BodyText>{labelText}</BodyText>
        <HelpIcon helpText={helpText} />
      </LabelHelpIcon>
      <Badge
        size='small'
        text='Visible to Participants'
        type={BadgeType.Secondary}
      />
    </>
  );
};

const LabelHelpIcon = styled.div(
  ({ theme }) => `
  display: flex;
  align-items: center;
  gap: ${theme.spacings[2]};
  `,
);
